import React from 'react';
import Seo from '../components/common/Seo';
import ProductDetails from '../components/products/ProductDetails';
import FAQ from '../components/home/faq/FAQ';

const ProductInfo = () => {
  return (
    <>
      <Seo
        title="Product Details | Agastya Agro Limited"
        description="Review product benefits, usage guidance, formulation details, and crop recommendations to choose the right Agastya Agro solution."
      />
      <ProductDetails />
      <div className='bg-[#F9F9FB]'> 
        <FAQ/>
      </div>
    </>
  
  )
  
};

export default ProductInfo;